import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 29355 29354"
    {...props}
  >
    <path
      d="m14677 14677 4332-3142 9679 3153-9684 3138-4327-3149zm3149-4327L14688 667l-3153 9678 3142 4332 3149-4327zm-7476 1178L667 14667l9678 3152 4332-3142-4327-3149zm1178 7476 3138 9683 3153-9678-3142-4332-3149 4327z"
      style={{
        fill: "#000",
        stroke: "#fefefe",
        strokeWidth: 412.068,
      }}
      className="stroke1 fill"

    />
  </svg>
)
export default SvgComponent
